<template>
    <div>
        <b-form-group label="Comunidad Autónoma" label-for="company">
            <b-form-input v-model="autonomousCommunity" placeholder="Comunidad Autónoma" autocomplete="off" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        autonomousCommunity: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localAutonomousCommunity: this.autonomousCommunity,
        }
    },
    watch: {
        autonomousCommunity(newVal) {
            this.localAutonomousCommunity = newVal
            this.$emit('update', { autonomous_community: this.localAutonomousCommunity })
        },
    },
}
</script>
